<template>
<div>
    <save-product :model="editing" @close="saved()" @cancel="editing = null" />

    <v-container>
        <div class="d-flex align-center">
            <h1>Products</h1>
            <v-btn color="primary" class="add-button" @click="add()" text>
                <v-icon left dark>mdi-plus</v-icon>
                Add product
            </v-btn>
            <v-btn color="primary" class="refresh-button" @click="refresh()" text>
                <v-icon left dark>mdi-reload</v-icon>
                Refresh products
            </v-btn>
        </div>
        <v-progress-linear :indeterminate="true" v-if="loading" />

        <v-row v-if="!loading">
            <v-col cols="12" md="6" lg="4" v-for="p in products" :key="p.id">
                <v-card>
                    <v-card-title>{{ p.name }}</v-card-title>
                    <v-card-subtitle>
                            <div>{{ p.typeText }}</div>
                            <div>Updated: {{ p.status.success ? moment(p.status.success).fromNow() : "Never" }}</div>
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-chip v-if="!p.status.failed && !p.status.success" outlined>
                            <v-progress-circular :indeterminate="true" color="primary" size="20" width="2" style="margin-right:5px" />
                            {{ p.status.message || "Building..." }}
                        </v-chip>
                        <v-chip v-if="p.status.failed" text-color="red" outlined>Failed</v-chip>
                        <v-chip v-if="p.status.success" text-color="green" outlined>Completed</v-chip>
                        <v-spacer />
                        <v-btn color="primary" @click="edit(p)" dark depressed :disabled="!p.status.failed && !p.status.success">
                            <v-icon left dark>mdi-pencil</v-icon>
                            Edit
                        </v-btn>
                        <v-btn color="red" @click="remove(p)" dark depressed :disabled="!p.status.failed && !p.status.success">
                            <v-icon left dark>mdi-delete</v-icon>
                            Delete
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<style scoped>
    .add-button, .refresh-button {
        margin-left: 10px;
    }
</style>

<script>
import { api } from '@/services/api';
import SaveProduct from "./SaveProduct";
import toast from "@/services/toast";
import TimerMixin from "@/mixins/Timer";
import modals from "@/services/modals";
import products from "@/services/products";
import moment from "moment";

export default {
    name: 'ProductList',
    data: () => ({
        products: [],
        editing: null,
        loading: false
    }),
    mixins: [TimerMixin],
    created: function() {
        this.refresh();
    },
    mounted: function() {
        this.timer(10000, async () => {
            if (this.products.some(p => !p.status.failed && !p.status.completed))
                await this.refresh(true);
        })
    },
    methods: {
        moment,
        async remove(product) {
            if (!await modals.show(`Are you sure you want to delete '${product.name}' and all its data?`, "Delete product"))
                return;

            await api("/admin/products/delete", { id: product.id });
            toast(`Product '${product.name}' deleted`);
            
            await this.refresh();
        },
        add() {
            this.editing = {
                "customerId": this.$route.params.id,
                "configuration": {}
            };
        },
        edit(data) {
            this.editing = {
                "customerId": this.$route.params.id,
                "id": data.id,
                "name": data.name,
                "type": data.type,
                "configuration": JSON.parse(JSON.stringify(data.configuration))
            };
        },
        saved() {
            toast(`Product '${this.editing.name}' ` + (this.editing.id ? "updated" : "created"));
            this.editing = null;
            this.refresh();
        },
        async refresh(noLoad) {
            if (!noLoad)
                this.loading = true;

            let data = {
                "customerId": this.$route.params.id
            };

            this.products = await api("/admin/products/list", data);
            this.products.forEach(p => p.typeText = products.text(p.type));

            this.loading = false;
        }
    },
    components: { SaveProduct }
};
</script>